<template>
  <vs-popup classContent="popup-example" title="Gönderilecek Koli" :active.sync="isSidebarActiveLocal">

    <b-row>
      <b-col><vs-input style="width: 100%;" disabled class="inputx" placeholder=" orderNumber "
          v-model="sipBarcode" /></b-col>
      <b-col><vs-input style="width: 100%;" class="inputx" placeholder="Giriniz.. " v-model="koliSayisi" /></b-col>
      <b-col style="    padding: 4px;"> <vs-button @click="koliAdetiKaydet()" color="primary" type="filled">Koli
          kaydet</vs-button></b-col>

    </b-row>


    <h4>
      Seçilen koli Miktarı: {{ select1 }}
      <Icon icon="mdi:tick-outline" stlye="font-size: 60px;" color="green" />
      <div>
        <Icon icon="clarity:tick-line" style="font-size: 16px; margin-left: 5px;" />
      </div>
    </h4>

    <vs-table stripe :data="donus">
      <template slot="thead">
        <vs-th sort-key="adet">Koli Barkodu</vs-th>
        <vs-th></vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="data[indextr].adet">
            {{ data[indextr].adet }}
          </vs-td>
          <vs-td>
            <b-row align-h="end">
              <b-col cols="12" md="auto" style="padding: 0">
                <b-button variant="outline-light" size="sm"
                  v-on:click="select1 = data[indextr].adet; gonder(data[indextr].adet)">
                  <Icon color="#28c76f" icon="ic:baseline-save-all" width="20" height="20" />
                </b-button>
              </b-col>
              <b-col cols="12" md="auto" style="padding: 0">
                <b-button variant="outline-light" size="sm" v-on:click="deleteKoliAdet(data[indextr])">
                  <Icon color="#EA5455" icon="ic:baseline-remove-circle" width="18" height="20" />
                </b-button>
              </b-col>

            </b-row>


          </vs-td>
        </vs-tr>

      </template>
    </vs-table>

  </vs-popup>
</template>

<script>
import { Icon } from "@iconify/vue2";
import state from "../../../../store/state";
import Store from "../../../../store/store";
import vSelect from "vue-select";
export default {
  components: { Icon, "v-select": vSelect, },
  props: {
    data: {
      default: () => { }
    },
    isSidebarActiveKoli: {
      type: Boolean,
      required: true
    },
  },
  data() {
    return {
      donus: [],
      koliSayisi: "",
      sipBarcode: "", 
      options1: [],
      select1: ""

    }
  },
  methods: {
    deleteKoliAdet(tr) {
      var vm = this;
      const vs = this.$vs;

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        quantity: tr.adet,
        token: Store.state.tokenId,
        stockCode: tr.stockCode,
        islem: "Sil"
      }; 
      soap.createClient(url, function (err, client) {
        if (err) { return; }
        client.koliAdetEkleSil(args, function (err, result) {
          if (result.koliAdetEkleSilResult == "-1") {
            Store.dispatch("logout");
          }
          let donus = JSON.parse(result.koliAdetEkleSilResult);
          try {
            if (donus.response == "Ok") {
              vm.koliAdetiListele();  
              vm.$root.$emit("getCekiDetay");
              vs.notify({
                title: "Ceki adedi Bilgisi",
                text: "Koli adedi kaydedildi.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center"
              });
            } else {
              vs.notify({
                title: "Ceki adedi Bilgisi",
                text: donus,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center"
              });
            }
          } catch (error) {
            vs.notify({
              title: "Ceki adedi Bilgisi",
              text: error,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });
          }

        });
      });
    },
    gonder(adet) {
      this.$root.$emit("gonderKoliAdet", adet);
    },
    koliAdetiListele() {
      var vm = this;
      const vs = this.$vs;
      vm.options1 = []
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        stockCode: vm.sipBarcode
      };  
      soap.createClient(url, function (err, client) {
        if (err) { return; }
        client.koliAdetListele(args, function (err, result) {
          if (result.koliAdetListeleResult == "-1") {
            Store.dispatch("logout");
          }
          vm.donus = JSON.parse(result.koliAdetListeleResult);
          try {
            if (vm.donus.response != "No") {
              let opt = [...new Set(vm.donus.map(x => x.adet))]; 
              opt.forEach((val, index) => {
                vm.options1.push({ text: val, value: val })
              }); 
              // donus
            } else {
              vs.notify({
                title: "Ceki adedi Bilgisi",
                text: vm.donus,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center"
              });
            }
          } catch (error) {
            vs.notify({
              title: "Ceki adedi Bilgisi",
              text: error,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });
          }

        });
      });
    },
    koliAdetiKaydet() {
      var vm = this;
      const vs = this.$vs;

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        quantity: vm.koliSayisi,
        token: Store.state.tokenId,
        stockCode: vm.sipBarcode
      }; 
      soap.createClient(url, function (err, client) {
        if (err) { return; }
        client.koliAdetEkleSil(args, function (err, result) {
          if (result.koliAdetEkleSilResult == "-1") {
            Store.dispatch("logout");
          }
          let donus = JSON.parse(result.koliAdetEkleSilResult);
          try {
            if (donus.response == "Ok") {
              vm.koliAdetiListele();
              vm.$root.$emit("getCekiDetay");
              vs.notify({
                title: "Ceki adedi Bilgisi",
                text: "Koli adedi kaydedildi.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center"
              });
            } else {
              vs.notify({
                title: "Ceki adedi Bilgisi",
                text: donus,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center"
              });
            }
          } catch (error) {
            vs.notify({
              title: "Ceki adedi Bilgisi",
              text: error,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });
          }

        });
      });
    },
  },
  computed: {

    isSidebarActiveLocal: {
      get() { 
        return this.isSidebarActiveKoli
      },
      set(val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },

  },
  watch: {
    isSidebarActiveKoli(val) {  
      if (val == true) {
        this.sipBarcode = this.data.barcode
        this.koliAdetiListele();
      }
    }
  },
}
</script>